import { FC, Fragment } from "react"
import { Translate } from "../../../../../../../../constant/Translate"
import { ScheduleInfoStaysType } from "../../../../../models/add"
import { SchedulesAddTable } from "../../../Table"
import { SchedulesAddStayProps } from "./models"
import { Styled } from "./styled"

const { TEXT_T286, TEXT_T287, TEXT_T605 } = Translate
const { StyledTitle } = Styled

export const SchedulesAddStay: FC<SchedulesAddStayProps> = (props) => {
  const {
    handleAddStayItem,
    handleDeleteStayItem,
    isTableLoading,
    isVisibleBtn,
    onClickStayTab,
    stayColumns,
    stayDataSource,
    stayIndexTabActive,
    stayRowSelection,
    staySelectedRowKeys,
    stayTabsItems,
  } = props

  return (
    <Fragment>
      <StyledTitle titleLeft={TEXT_T605} />
      <SchedulesAddTable
        activeKey={stayIndexTabActive}
        addText={TEXT_T286}
        columns={stayColumns}
        dataSource={stayDataSource}
        dataTableSelected={staySelectedRowKeys}
        deleteText={TEXT_T287}
        handleAdd={handleAddStayItem}
        handleDelete={handleDeleteStayItem}
        id="table-schedules-add-stay"
        isLoading={isTableLoading}
        isVisibleBtn={isVisibleBtn}
        items={stayTabsItems}
        onTabClick={onClickStayTab}
        rowKey={(record: ScheduleInfoStaysType) => record.travelStayId}
        rowSelection={stayRowSelection}
      />
    </Fragment>
  )
}
